import { createSlice } from '@reduxjs/toolkit';
import {
    createLoadElearningItemsThunk,
    createLoadElearningItemThunk,
} from '../elearning/elearning.js';

export const loadOsItemsIfNeeded = createLoadElearningItemsThunk('os', 'onlinestudio');

export const loadOsItem = createLoadElearningItemThunk('os');

const osSlice = createSlice({
    name: 'os',
    initialState: {
        status: 'idle',
        list: [],
        error: null,
        page: -1
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadOsItemsIfNeeded.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loadOsItemsIfNeeded.fulfilled, (state, action) => {
                const { payload } = action;

                state.status = 'success';
                state.list = payload.reload ? [...payload.list] : [...state.list, ...payload.list];
                state.page = payload.page;
                state.total = payload.total;
                state.search = payload.search;
            })
            .addCase(loadOsItemsIfNeeded.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error;
            })
            .addCase(loadOsItem.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loadOsItem.fulfilled, (state, action) => {
                const { payload } = action;

                state.status = 'success';
                state.current = payload;
                state.dirty = false;
            })
            .addCase(loadOsItem.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error;
            })
    },
});

export default osSlice.reducer;
